'use client';

import { DetailedHTMLProps, HTMLAttributes, useState } from 'react';

import { cx } from '@/ui/cva';

import { StoryVideoButton } from './StoryVideoButton';
import { StoryVideoPlayer } from './StoryVideoPlayer';

type StoryVideoProps = DetailedHTMLProps<
    HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
> & {
    locale?: string;
    url: string;
};

export function StoryVideo({
    className,
    children,
    locale,
    url,
    ...props
}: StoryVideoProps) {
    const [isPlaying, setPlaying] = useState(false);

    return (
        <div className={cx('relative aspect-video', className)} {...props}>
            {!isPlaying ? (
                <>
                    {children}

                    <StoryVideoButton onClick={() => setPlaying(true)} />
                </>
            ) : (
                <StoryVideoPlayer locale={locale} url={url} />
            )}
        </div>
    );
}
